import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { namesConflict } from "@shared/helpers/volunteer-organization";
import { Roles } from "@shared/Roles";
import { remult } from "remult";
import { VolunteerOrgActivity } from "../volunteer-org-activity/entity";
import { VolunteerOrgActivityDomain } from "./entity";

export const VolunteerOrgActivityDomainEntityConfig: HyperEntityConfig<VolunteerOrgActivityDomain> =
  {
    allowApiRead: true,
    allowApiCrud: Roles.AdminsAndManager,
    apiPrefilterPerRole: (filter) => {
      if (!remult.user) return;
      filter(Roles.AdminsAndManager, true);
      filter(Roles.User, false);
    },
    allowInsertPerRole(allow) {
      allow(Roles.AdminsAndManager, true);
    },
    allowDeleteAndUpdatePerRole(allow) {
      allow(Roles.AdminsAndManager, true);
    },
    async saving(entity) {
      entity.name = entity.name?.trim() ?? "";
      if (!entity.name) {
        throw new Error("שם התחום חובה");
      }
      const others = await remult.repo(VolunteerOrgActivityDomain).find();
      if (
        others.some(
          (row) => row.id !== entity.id && namesConflict(row.name, entity.name),
        )
      ) {
        throw new Error("כבר קיים תחום בשם זה");
      }
    },
    async deleting(entity) {
      const count = await remult
        .repo(VolunteerOrgActivity)
        .count({ domainId: entity.id });
      if (count > 0) {
        throw new Error("לא ניתן למחוק תחום שמשויך לארגונים. ניתן לכבות אותו.");
      }
    },
  };
